import {all, call, put, takeLatest} from 'redux-saga/effects'
import {actions} from './actions'
import {getErrorAction, getSuccessAction} from '../utility'
import feathers from 'utility/client'
import { has } from 'lodash'

export function* watchLogin() {
  yield takeLatest(actions.LOGIN, function* ({email, code = false, onSuccess, onError}) {
    try {
      const payload = {
        strategy: 'video-window',
        email,
        admin: true
      }

      if (code) {
        payload.code = code
      }

      const result = yield call(() => feathers.authenticate(payload))
      onSuccess(result)

      yield put({
        type: getSuccessAction(actions.LOGIN),
        user: result.user
      })
    } catch (e) {
      yield put({
        type: getErrorAction(actions.LOGIN)
      })
      onError(e)
    }
  })
}

export function* watchReAuthenticate() {
  yield takeLatest(actions.REAUTHENTICATE, function* ({onSuccess, onError}) {
    try {
      const result = yield call(() => feathers.reAuthenticate())

      if (!has(result.user, 'permissions') || !result.user.permissions.length) {
        console.log('permissions changed', result)
        yield put({
          type: getErrorAction(actions.LOGIN)
        })
      } else {
        onSuccess(result)
        yield put({
          type: getSuccessAction(actions.LOGIN),
          user: result.user
        })
      }
    } catch (e) {
      console.log(e)
      yield put({
        type: getErrorAction(actions.LOGIN)
      })
      onError(e)
    }
  })
}

export const AuthenticationSaga = function* () {
  yield all([watchLogin(), watchReAuthenticate()])
}
